<script lang="ts">
    import { themeType as ThemeTypeEnum } from '../constants/Enums';
    import { ADDRESS_INFO_LOGO, ADDRESS_INFO_LOGO_BLACK } from '../constants/imgList';
    import { isLogin } from '../store';

    import webp from '@/actions/webp';
    import { CREDIT_CARD_CAT, CREDIT_CARD_ADDRESS } from '@/configs/compliance';

    export let themeType = ThemeTypeEnum.WHITE;
    export let catInfoLines = [CREDIT_CARD_CAT.CARD_MSI];

    $: resolvedTheme =
        themeType === ThemeTypeEnum.NULL ? ThemeTypeEnum.WHITE : themeType;
    $: themeModifierClass = `ThemeTypeEnum--${resolvedTheme}`;
</script>

<div class="address-info {themeModifierClass}"
class:address-info--black={themeType === ThemeTypeEnum.BLACK && $isLogin}
style="color: {themeType === ThemeTypeEnum.WHITE ? '#474747' : '#ffffff'};"
>
    <div
        class="top-title"
    >
        {#each catInfoLines as catInfoLine, index}
            {catInfoLine}{#if index < catInfoLines.length - 1}<br />{/if}
        {/each}
        <div class="line"></div>
        {CREDIT_CARD_ADDRESS}
    </div>
    <div class="bottom-logo">
        <img
            class="img"
            use:webp
            src={resolvedTheme === ThemeTypeEnum.BLACK
                ? ADDRESS_INFO_LOGO
                : ADDRESS_INFO_LOGO_BLACK}
            alt=""
            loading="lazy"
        />
    </div>
</div>

<style lang="scss">
    .address-info {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 20px 56px;
        background-color: #ffffff;
        margin-top: 1.2rem;

        &.ThemeTypeEnum--BLACK {
            background-color: #000000;
            margin-top: 0.4rem;
        }
    }
    .address-info--black {
        position: relative;
        top: -40px;
    }

    .top-title {
        width: 100%;
        box-sizing: border-box;
        font-family: DiDiSans-Pro-Regular;
        font-size: 20px;
        line-height: 32px;
        text-align: center;
        letter-spacing: normal;
        opacity: 0.6;
    }

    .top-title .line {
        height: 16px;
    }

    .bottom-logo {
        margin-top: 16px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .img {
        width: 195px;
        height: 36px;
    }
</style>
